import React, { useState } from 'react';
import axios from "axios";
import MobileNav from '../components/MobileNav';
import logo from '../assets/images/wordb_logo.svg';
import { FaPlay } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../components/Footer';
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { IoMdArrowRoundBack } from "react-icons/io";
import { API } from '../config'; 

const Lobby1 = () => {
  const [roomId, setRoomId] = useState("");
  const navigate = useNavigate();

    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);
    const [isCreatingGame, setIsCreatingGame] = useState(false);
    const [isJoiningRoom, setIsJoiningRoom] = useState(false);

  const createRoom = async () => {
    setIsCreatingGame(true);
    try {
        const token = localStorage.getItem("authToken");
        const response = await axios.post(
            `${API}/api/game/create-room`,
            { },
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        navigate(`/game/${response.data.roomId}`);
    } catch (err) {
        toast.error(err.response?.data?.message || "Failed to create room");
    } finally {
        setIsCreatingGame(false);
    }
  };

  const validateForm = () => {
    //console.log("Validating Game ID...");
    if (!roomId.trim()) {
        toast.error("Game ID is required.");
        return false;
    }
    if (roomId.length !== 4) {
        toast.error("Game ID must be exactly 4 characters.");
        return false;
    }
    return true;
  };

  const joinRoom = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
        return; // Stop submission if validation fails
    }

    setIsJoiningRoom(true);

      try {
          const token = localStorage.getItem("authToken");
          await axios.post(
              `${API}/api/game/join-room`,
              { roomId },
              {
                  headers: { Authorization: `Bearer ${token}` },
              }
          );
          navigate(`/game/${roomId}`);
      } catch (err) {
          toast.error(err.response?.data?.message || "Failed to join room");
      } finally {
          setIsJoiningRoom(false);
      }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section className='lobby1'>

        {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
        {isQueryOpen && <Query onClose={toggleQuery} />}

        <Link to="/home" className='left-icon-link'>
            <IoMdArrowRoundBack className='icon' />
        </Link>

        <MobileNav />

        <div className="logo-div">
            <img src={logo} alt="" />
        </div>

        <div className="lobby1-content"> 
            <button className='btn create-btn' onClick={createRoom}>
                <span>{ isCreatingGame ? 'Creating game...' : 'Create Game'}</span>
                <FaPlay className='icon'/>
            </button>

            <div className="line-div">
                <hr className="line"/>
                <p className="or">or</p>
                <hr className="line"/>
            </div>

            <form onSubmit={joinRoom} className="game-id-form">
              <div className="form-input">
                  <label htmlFor="nickname">Enter Game ID</label>
                  <input 
                      type="text" 
                      id="roomId" 
                      name="roomId" 
                      placeholder="KQ5T" 
                      value={roomId}
                      onChange={(e) => setRoomId(e.target.value)}
                      autoComplete='off'
                  />
              </div>

              <button type='submit' className='btn join-btn'>
                  <span>{ isJoiningRoom ? 'Joining game...' : 'Join Game'}</span>
                  <FaArrowRight className="icon"/>
              </button>
            </form>
        </div>
      </section>

      <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
    </>
  )
}

export default Lobby1